import { render, staticRenderFns } from "./alertbar.vue?vue&type=template&id=f272757e&scoped=true"
import script from "./alertbar.vue?vue&type=script&lang=js"
export * from "./alertbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272757e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3833976396/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f272757e')) {
      api.createRecord('f272757e', component.options)
    } else {
      api.reload('f272757e', component.options)
    }
    module.hot.accept("./alertbar.vue?vue&type=template&id=f272757e&scoped=true", function () {
      api.rerender('f272757e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/alertbar.vue"
export default component.exports